import { createReducer, on } from '@ngrx/store';
import * as BookingActions from './bookings.actions';
import { Booking } from './bookings.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface BookingsState {
    bookings: Booking[];
    booking: Booking | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialBookingsState: BookingsState = {
    bookings: [],
    booking: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// Bookings Reducer
export const bookingsReducer = createReducer(
    initialBookingsState,

    // On Load Bookings
    on(BookingActions.loadBookings, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(BookingActions.loadBookingsSuccess, (state, { bookings }) => ({
        ...state,
        isLoading: false,
        bookings: bookings,
    })),
    on(BookingActions.loadBookingsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Booking
    on(BookingActions.loadBooking, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(BookingActions.loadBookingSuccess, (state, { booking }) => ({
        ...state,
        isLoading: false,
        booking: booking,
    })),
    on(BookingActions.loadBookingFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(BookingActions.createBooking, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(BookingActions.createBookingSuccess, (state, { booking }) => ({
        ...state,
        isLoading: false,
        bookings: [...state.bookings, booking],
    })),
    on(BookingActions.createBookingFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(BookingActions.updateBooking, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(BookingActions.updateBookingSuccess, (state, { booking }) => ({
        ...state,
        isLoading: false,
        bookings: state.bookings.map((b) =>
            b.id === booking.id ? booking : b
        ),
    })),
    on(BookingActions.updateBookingFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(BookingActions.deleteBooking, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(BookingActions.deleteBookingSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        bookings: state.bookings.filter((b) => b.id !== id),
    })),
    on(BookingActions.deleteBookingFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
